__turbopack_context__.v({
  "showAllAgendaButton": "ShowAllButton-module-scss-module__bvnb4G__showAllAgendaButton",
});
